var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{style:(_vm.showContact),attrs:{"title":_vm.name,"aria-label":_vm.name,"type":"button"},on:{"click":function($event){return _vm.selectContact(_vm.name)}}},[_c('span',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }